"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorContextProvider = exports.ColorContext = void 0;
var react_1 = __importStar(require("react"));
function hexToHSL(hex) {
    console.log(hex);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    console.log(result);
    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);
    (r /= 255), (g /= 255), (b /= 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s;
    var l = (max + min) / 2;
    if (max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return { h: Math.round(h * 360), s: Math.round(s * 100), l: Math.round(l * 100) };
}
var hslToHex = function (h, s, l) {
    l /= 100;
    var a = (s * Math.min(l, 1 - l)) / 100;
    var f = function (n) {
        var k = (n + h / 30) % 12;
        var color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, '0'); // convert to Hex and prefix "0" if needed
    };
    return "#" + f(0) + f(8) + f(4);
};
var windowX = window;
// Injects color variables as HSL into dom and returns the Hex in a promise.
var colorsPromise = new Promise(function (res, rej) {
    var j = 0;
    var i = window.setInterval(function () {
        var _a, _b;
        if (j++ === 5 * 1000) {
            window.clearInterval(i);
            throw new Error("Unable to resolve colors!");
        }
        if ((_a = windowX.ignite) === null || _a === void 0 ? void 0 : _a.userService) {
            // Inject colors into vars from guide.
            (_b = windowX.ignite.userService) === null || _b === void 0 ? void 0 : _b.getGuideAttributes().then(function (attrs) {
                windowX.clearInterval(i);
                var primaryHex = attrs.uiConfig.cssConfig.palette.contextual.primary.defaultColor;
                var secondaryHex = attrs.uiConfig.cssConfig.palette.contextual.secondary.defaultColor;
                try {
                    var primary = hexToHSL(primaryHex);
                    var secondary = hexToHSL(secondaryHex);
                    var css = " :root {\n              --color-primary: hsl(" + primary.h + ", " + primary.s + "%, " + primary.l + "%);\n              --color-primary-h: " + primary.h + ";\n              --color-primary-s: " + primary.s + "%;\n              --color-primary-l: " + primary.l + "%;\n              --color-secondary: hsl(" + secondary.h + ", " + secondary.s + "%, " + secondary.l + "%);\n              --color-secondary-h: " + secondary.h + ";\n              --color-secondary-s: " + secondary.s + "%;\n              --color-secondary-l: " + secondary.l + "%;\n            }\n          ";
                    var head = document.head || document.getElementsByTagName('head')[0];
                    var style = document.createElement('style');
                    head.appendChild(style);
                    style.appendChild(document.createTextNode(css));
                    return res({ primary: primaryHex, secondary: secondaryHex });
                }
                catch (e) {
                    return rej("Error parsing custom colors from attrs " + attrs);
                }
            });
        }
    }, 100);
});
var DEFAULT_COLOR_STATE = {
    colors: { primary: '#000', secondary: '#000' },
    setColors: function () { return undefined; }
};
var ColorContext = react_1.default.createContext(DEFAULT_COLOR_STATE);
exports.ColorContext = ColorContext;
var ColorContextProvider = function (props) {
    var _a = react_1.useState(DEFAULT_COLOR_STATE), state = _a[0], setState = _a[1];
    react_1.useEffect(function () {
        colorsPromise.then(function (colors) {
            setState(__assign(__assign({}, state), { colors: colors }));
        });
    }, []);
    return (react_1.default.createElement(ColorContext.Provider, { value: state }, props.children));
};
exports.ColorContextProvider = ColorContextProvider;
//# sourceMappingURL=guide.utils.js.map